<div id="full-width-modal" class="modal fade show" tabindex="-1" aria-labelledby="modalTemplate" style="display: block;"
  aria-modal="true" role="dialog" #modalContainer>
  <div class="modal-dialog modal-dialog-scrollable modal-full-width">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalTemplate">{{ 'attendance.chatSelectTemplate.title' | translate }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body" style="max-height: 100vh">
        <div [hidden]="step != 1">
          <wa-template [channel]="selectedChannel" (onSelectTemplate)="onSelectTemplate($event)" />
        </div>

        <div [hidden]="step != 2">
          <wa-template-message [variables]="variables" [contact]="selectedContact" [template]="selectedTemplate"
            (templateParams)="setTemplateMessage($event)" />
        </div>
      </div>
      <div class="modal-footer d-flex align-items-center justify-content-between w-100">
        <div class="d-flex justify-content-center align-items-center gap-2">
          <button class="btn btn-outline-dark rounded-pill" (click)="previousStep()">
            <i class="ri-arrow-left-s-line"></i>
            {{ 'attendance.chatSelectTemplate.back' | translate }}
          </button>
          <button class="btn btn-dark rounded-pill gap-2" (click)="selectTemplateMessage()">
            <i class="ri-check-line"></i>
            {{ 'attendance.chatSelectTemplate.send' | translate }}
          </button>
        </div>

        <button type="button" class="btn btn-primary" (click)="close()">
          {{ 'attendance.chatSelectTemplate.close' | translate }}
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div>